import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BhUserToGroup extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'BhUserToGroup'
  // Define default properties here
  static instanceDefaults() {
    return {
      user_id: null,
      group_id: null
    }
  }
}
const servicePath = 'bh-user-to-group';
const servicePlugin = makeServicePlugin({
  Model: BhUserToGroup,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
